<div class="page d-flex flex-column justify-content-center align-items-center text-center h-100">
    <h2 class="fs-1 mt-lg-5 mt-3" color="primary">{{ "title.page_not_found_title" | translate }}</h2>
    <img src="assets/img/error.svg" style="max-width: 30vw;" alt="Not found">
    <p class="fs-5">{{ "title.page_not_found_description" | translate }}</p>
</div>